import './styles.scss';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Container, Row } from 'reactstrap';
import CategoryCampaigns from './CategoryCampaigns';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { menuListSelector } from '~redux/menu/selectors';
import HorizontalSlider from '~view/widgets/HorizontalSlider';

const ProductListHeader: React.FC<{
  category: string;
  subCategory?: string;
}> = ({ category, subCategory }) => {
  const auth = useSelector(authUserSelector);
  const menuList = useSelector(menuListSelector);
  const menu = useMemo(
    () => menuList?.find((menu) => menu.title === category),
    [menuList, category]
  );

  return (
    <>
      <Container className="border-bottom mb-3">
        <div className="p-3">
          <Link className="mr-2" to="/home">
            Home
          </Link>
          /
          {category && (
            <Link
              to={menu?.product_list_path!}
              className={'mx-2' + (!subCategory ? ' text-muted' : '')}
            >
              {category}
            </Link>
          )}
          {subCategory && (
            <>
              /<span className="mx-2 text-muted">{subCategory}</span>
            </>
          )}
        </div>
      </Container>
      <Container>
        <div className="list-view-header mb-0">
          <div>
            <h1 className="mb-2" style={{ fontSize: '30px' }}>
              {subCategory ?? category}
            </h1>
          </div>
        </div>
      </Container>
      {category && !subCategory && (
        <Container className="mb-5">
          <HorizontalSlider
            xs={2}
            sm={3}
            md={4}
            lg={5}
            xl={6}
            contentAlign="left"
          >
            {menu?.sub_categories.map((subcategory, index) => (
              <Link to={subcategory.path} className="category-link text-center">
                <img
                  src={require(`../../../../../assets/images/homecategory/${
                    menu.id
                  }_${index + 1}.jpg`)}
                  alt="shop"
                  className="shop-subcategory-img rounded-pill mb-2"
                />
                <p className="mb-0 font-weight-bold">{subcategory.name}</p>
              </Link>
            ))}
          </HorizontalSlider>
        </Container>
      )}
      {auth && category && !subCategory && (
        <CategoryCampaigns category={category} />
      )}
    </>
  );
};

export default ProductListHeader;
